<template>
    <div>
        <core-error-alerts :errors="errorMsgList"></core-error-alerts>
        <div class="my-4">
            <h1>{{ tenantData.name }}</h1>
        </div>

        <div class="my-4">
            Other things to add:  events, table of users (internal, external), Stripe info, etc.
        </div>

        <div class="my-4">
            <pre>{{ tenantData }}</pre>
        </div>

        <div class="my-4">
            <h4>Exports</h4>
            <div class="">
                <b-button :href="vendorExcelDownloadUrl" variant="subtle-primary" size="lg" download>
                    Download Vendor Export Excel File
                </b-button>
            </div>
            <!-- put form here for getting export JSON for single model/app -->
        </div>
    </div>
</template>

<script>
import { suppliosHqApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';

export default {
    name: 'HqTenantDetail',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        tenantId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            tenantData: {},  // put here after getting from API
        }
    },
    computed: {
        vendorExcelDownloadUrl() {
            const pathAfterApi = suppliosHqApi.tenants.objectUrl(this.tenantId) + 'download_vendor_export_excel/';
            const theUrl = `/api/${pathAfterApi}`;
            console.log('vendorExcelDownloadUrl', theUrl);
            return theUrl;
        },
    },
    mounted: function() {
        this.getData();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        getData: function() {
            this.loading = true;
            return suppliosHqApi.tenants.retrieve(this.tenantId)
                .then(response => {
                    this.tenantData = response.data;
                    return true;
                })
                .catch(err => {
                    this.apiErrorHandler(err);
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                })
        },
    }
}
</script>

<style>

</style>